import { Link } from 'react-router-dom';

export default function About() {
  return (
    <main className="container py-5">
      <h1 className="display-5 fw-bold mb-4 text-center">About Us</h1>
      <p className="lead text-center mb-5">
        We're the Equivalents Senior Design team at the University of Connecticut,
        building a platform that blends technology, art, and spirit wear.
      </p>

      <div className="row g-4">
        <div className="col-md-6">
          <div className="p-4 bg-white rounded-3 shadow-sm h-100">
            <h2 className="h5 fw-bold">Our Mission</h2>
            <p>
              To create a bridge between creative expression and NFT technology,
              allowing students to personalize their very own UConn merch.
            </p>
          </div>
        </div>



        <div className="col-md-6">
          <div className="p-4 bg-white rounded-3 shadow-sm h-100">
            <h2 className="h5 fw-bold">Meet the Team</h2>
            <ul className="list-unstyled">
              <li><strong>Budly</strong> – Our Team's Sponsor!</li>
              <li><strong>Professor Philip Bradford</strong> – Our Mentor!</li>
              <li><strong>Brent</strong> – Back End Lead</li>
              <li><strong>Will</strong> – Back End & Hardware</li>
              <li><strong>Ohemaa</strong> – Front End & Design</li>
              <li><strong>Ahmed</strong> – Front End</li>
            </ul>
          </div>
        </div>
      </div>




      <footer className="border-top py-4 text-center small text-muted mt-5">
        © 2025 Equivalents - UConn Senior Design | <Link to="/" className="text-decoration-none">Home</Link>
      </footer>
    </main>
  );
}

